import * as React from "react";
import {Accordion, Icon, Message} from "semantic-ui-react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../redux/reducers/generalReducer";
import {
    errorResponsetoString,
    FeedbackData, FeedbackTypeEnum,
    infoResponsetoString,
    timestampToString
} from "../utils/FeedbackMessageUtils";

interface IFeedbackMessage {
    /** info message */
    message: string;
    /** The info details to be optionally shown to the user. */
    details?: any;
    /** Additional translation options */
    translationOptions?: any;
    /**
     * Specifies if the details have already been translated.
     * This for more complex detail string that cannot be computed here.
     */
    translatedDetails?: boolean;

    /** the details should not be converted to string(for Info and Error) */
    keepFormat?: boolean;
}

export interface IError extends IFeedbackMessage {
    /** Time stamp the error was received, Date.now() */
    timestamp: number;
}

export interface IInfo extends IFeedbackMessage {
    /** Time stamp the error was received, Date.now() */
    timestamp: number;
}

export interface IWarning extends IFeedbackMessage {
    /** Time stamp the error was received, Date.now() */
    timestamp?: number;
}

interface IFeedbackMessageProps extends ITranslatedComponent {
    /** Data to be displayed, either for an error or for info. */
    data: FeedbackData;

    /** The type of the information. */
    type: FeedbackTypeEnum;

    className?: string;
}

interface IFeedbackMessageState {
    detailsOpen: boolean;
}

class FeedbackMessage extends React.Component<IFeedbackMessageProps, IFeedbackMessageState> {
    constructor(props: IFeedbackMessageProps) {
        super(props);
        this.state = {
            detailsOpen: false,
        };
    }

    private renderDetails = (type: FeedbackTypeEnum, data: FeedbackData) => {
        switch (type) {
            case FeedbackTypeEnum.ERROR:
                return (
                    <div>
                        {
                            // @ts-ignore
                            timestampToString(data.timestamp)
                        }
                        <div className='margin-top--10px'>{data.keepFormat ? data.details : errorResponsetoString(data.details)}</div>
                    </div>
                );
            case FeedbackTypeEnum.INFO:
                return (
                    <div>
                        {
                            // @ts-ignore
                            timestampToString(data.timestamp)
                        }
                        <div className='margin-top--10px'>{data.keepFormat ? data.details : infoResponsetoString(data.details)}</div>
                    </div>
                );
            case FeedbackTypeEnum.WARNING:
                return (
                    <div>
                        {
                            // @ts-ignore
                            timestampToString(data.timestamp)
                        }
                        <div className='margin-top--10px'>{data.details}</div>
                    </div>
                );
            default:
                return <></>;
        }
    }

    render() {
        const {
            t,
            data,
            type,
            className
        } = this.props;

        let detailsCont = undefined;
        if (data.details && data.timestamp) {
            if (typeof data.details === "string") {
                detailsCont = (
                    <div>
                        {timestampToString(data.timestamp)}
                        <p>{data.translatedDetails ? data.details : t(data.details)}</p>
                    </div>
                );
            } else {
                detailsCont = this.renderDetails(type, data);
            }
        } else if (data.timestamp) {
            detailsCont = <div>{timestampToString(data.timestamp)}</div>;
        }

        return (
            <div
                className={className}
            >
                <h1 style={{fontSize: "16px"}}>{data.translationOptions ? t(data.message, data.translationOptions) : t(data.message)}</h1>
                {
                    detailsCont &&
                    <Message>
                        <Accordion>
                            <Accordion.Title
                                active={this.state.detailsOpen}
                                onClick={() => this.setState({detailsOpen: !this.state.detailsOpen})}
                            >
                                <Icon name="dropdown" />
                                {t("MESSAGEDETAILS")}
                            </Accordion.Title>
                            <Accordion.Content
                                active={this.state.detailsOpen}
                            >
                                {
                                    detailsCont
                                }
                            </Accordion.Content>
                        </Accordion>
                    </Message>
                }
            </div>
        );
    }
}

export default translate(['ERRORS', 'INFO', 'WARNING'])(FeedbackMessage);



// WEBPACK FOOTER //
// ./src/components/FeedbackMessage.tsx